export const __BROWSER__ = typeof window !== 'undefined';
export const __SERVER__ = !__BROWSER__;
